export default "__VITE_ASSET__BVgGz9Eq__"